<template>
    <div class="form-content">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="项目方">
                <el-input v-model="userInfo.company" disabled></el-input>
            </el-form-item>
<!--            <el-form-item label="所属项目">-->
<!--                <el-select v-model="form.id" placeholder="请选择所属项目">-->
<!--                    <el-option-->
<!--                        v-for="item in projects"-->
<!--                        :key="item.id"-->
<!--                        :label="item.name"-->
<!--                        :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->

            <el-form-item label="人员数据">
                <div class="upload-tip">请下载<a href="http://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/templet/%E6%88%90%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx" class="upload_link">系统模版</a>后，导入填写好的表格模板</div>
                <el-upload
                    class="upload-demo"
                    drag
                    name="member"
                    :on-success="uploadSuccess"
                    :on-remove="removeFile"
                    :headers="headers"
                    :limit="1"
                    accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                    :action="actionUrl">
                    <i class="el-icon-upload"></i>
                    <!--<i class="iconfont icon-shangchuanwenjian"></i>-->
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">一次最多上传1万行数据，超出部分请分次上传</div>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="toNextStep">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
export default {
    name: 'Step1',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            actionUrl: process.env.VUE_APP_BASE + '/api/user/member/upload',
            userInfo: {},
            projects: [],
            headers: {},
            form: {
                path: '',
                id: ''
            }
        }
    },
    mounted () {
        this.headers = { token: localStorage.getItem('token') }
        this.getUserInfo()
    },
    methods: {
        toNextStep () {
            if (!this.form.path) {
                this.$message.warning('请上传文件')
            } else {
                router.push(`/index/member/import/step2?id=${this.form.id}&path=${this.form.path}`)
            }
        },
        uploadSuccess (res) {
            if (res.code === 0) {
                this.form.path = res.data.fullpath
            } else {
                this.$message.warning(res.message)
            }
        },
        removeFile (res) {
            this.form.path = ''
        },
        getProjects () {
            this.$http.get('/api/projectlist', qs.stringify({
                keyword: ''
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.projects = res.data.listData
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getUserInfo () {
            try {
                if (window.localStorage.getItem('USERINFO')) {
                    this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
                } else {
                    throw new Error('获取本地userInfo失败')
                }
            } catch (err) {
                this.$http.get('/api/userinfo')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .upload_link {
        text-decoration: underline;
    }
</style>
